import { render } from "./Avatar.vue?vue&type=template&id=bdae0c58"
const script = {}
script.render = render

export default script